import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { getSnackbar } from "../state/mainGui";

import styles from "./Snackbar.module.css";

const titles = {
  error: <FormattedMessage id="message.error" defaultMessage="Error:" />,
  warning: <FormattedMessage id="message.warning" defaultMessage="Warning:" />,
  info: <FormattedMessage id="message.info" defaultMessage="Message:" />,
};

// Messages from non-React components can only be translated here
const MESSAGES: { [id: string]: React.ReactNode } = {
  "error.failed_to_create_simulation": (
    <FormattedMessage
      id="error.failed_to_create_simulation"
      defaultMessage="Failed to create simulation"
    />
  ),
  "error.failed_to_initialize_simulation": (
    <FormattedMessage
      id="error.failed_to_initialize_simulation"
      defaultMessage="Failed to initialize simulation"
    />
  ),
  "error.simulation_crashed": (
    <FormattedMessage
      id="error.simulation_crashed"
      defaultMessage="Simulation crashed. See header for details"
    />
  ),
  "error.connection_limit_reached": (
    <FormattedMessage
      id="error.connection_limit_reached"
      defaultMessage="Too many users are watching this simulation at the moment. Please try again later!"
    />
  ),
  "error.simulation_no_longer_active": (
    <FormattedMessage
      id="error.simulation_no_longer_active"
      defaultMessage="This simulations is no longer active. You may start a new simulation."
    />
  ),
  "error.starting_simulation_failed": (
    <FormattedMessage
      id="error.starting_simulation_failed"
      defaultMessage="At this moment, we could not start the simulation. You can try again in a few minutes. If it doesn't solve the problem, please contact our Service Desk."
    />
  ),
  "error.starting_simulation_failed_timedstructurecontrols_has_state_processing": (
    <FormattedMessage
      id="error.starting_simulation_failed_timedstructurecontrols_has_state_processing"
      defaultMessage="Please try again in a few moments. A change is still processing. Playing will work again shortly."
    />
  ),
  "error.pausing_simulation_failed": (
    <FormattedMessage
      id="error.pausing_simulation_failed"
      defaultMessage="At this moment, we could not pause the simulation. You can try again in a few minutes. If it doesn't solve the problem, please contact our Service Desk."
    />
  ),
  "error.failed_to_edit_structure": (
    <FormattedMessage
      id="error.failed_to_edit_structure"
      defaultMessage="Failed to edit the structure. You can try again in a few minutes. If it doesn't solve the problem, please contact our Service Desk."
    />
  ),
  "error.failed_to_edit_structure_missing_structure_id": (
    <FormattedMessage
      id="error.failed_to_edit_structure_missing_structure_id"
      defaultMessage="Failed to edit the structure. Structure ID is missing from the GeoJSON file."
    />
  ),
  "error.no_valid_model_bounds": (
    <FormattedMessage
      id="map_error.no_valid_bounds_therefore_force_quit"
      defaultMessage="The bounds of the Model are invalid. Please check the bounds."
    />
  ),
};

const Snackbar = () => {
  const snackbar = useSelector(getSnackbar);

  return (
    <div className={styles.snackbar}>
      {snackbar.map((message) => (
        <div key={message.id} className={`${styles.snackbarMessage} ${styles[message.level]}`}>
          <div>
            <h3 className={styles.title}>{titles[message.level]}</h3>
            <p>
              {typeof message.message === "string"
                ? MESSAGES[message.message] || message.message
                : message.message}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Snackbar;
